module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARBAMAAAAmgTH3AAAAKlBMVEUAAAD///////////////////////////////////////////////////+Gu8ovAAAADnRSTlMAESIzRFVmd4iZqrvM3UwhkGcAAABvSURBVAjXY2AQYoAAtjMJEEamwFYI4yKDjACYsYGBZQKYcYCBbQGYMZlxB0TKk60Bophb8SCEwbIhE2piO8cEBt9NQAZPQpfgQe8ABgbGY6ynExiXAYWkC5iB4iBV1Q4MDN4gBtPuJBaIGUxVOwUA62wWN4B2QmsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/phone.png
// module id = 660
// module chunks = 0